<template>
  <div
    class="ticket-check"
    v-if="ticket.id"
  >
    <scroller>
      <div
        class="ticket-check-scroller"
        v-max-height="{
          el: ['.ticket-check-actions'],
          offset: 60
        }"
      >
        <table class="table">
          <TicketCheckHeader :ticket="ticket" />

          <tbody>
            <template v-for="(bet, i) in ticket.bets">
              <BetRow
                :key="`${i}-${Date.now()}`"
                :bet="bet"
                :is-operator="isUserOperator"
                :is-system="isSystem"
                :odd="convertOdd(parseFloat(bet.oddValue), oddType, 2)"
                :full-results-enabled="ticket.fullResultsEnabled"
              />
            </template>
          </tbody>
        </table>

        <table class="table">
          <thead v-if="ticket.ticketCombinationGroups.length && ticket.type === '2'">
            <tr class="is--dark text-uppercase">
              <th colspan="2">
                {{ getTranslation('ticket.system') }}
              </th>

              <th colspan="3">
                {{ getTranslation('main.combinations') }}
              </th>

              <th colspan="3">
                {{ getTranslation('ticket.min_value') }} {{ getTranslation('main.winnings') }}
              </th>

              <th colspan="3">
                {{ getTranslation('ticket.max_value') }} {{ getTranslation('main.winnings') }}
              </th>
            </tr>
          </thead>

          <tbody v-if="ticket.type === '2'">
            <tr
              v-for="(item, i) in ticket.ticketCombinationGroups"
              :key="i"
              class="border_bottom border-double"
            >
              <td colspan="2">{{ item.displayType }}</td>
              <td colspan="3">{{ item.numberOfCombinations }}</td>
              <td colspan="3">{{ formatNumber(item.minGain, 2, 2) }}</td>
              <td colspan="3">{{ formatNumber(item.maxGain, 2, 2) }}</td>
            </tr>
          </tbody>

          <TicketCheckFooter :ticket="ticket" />
        </table>
      </div>
    </scroller>

    <div class="ticket-check-actions">
      <div v-if="showCancelAction">
        <button
          class="btn btn-primary btn-block ripple max-height"
          @click="handleCancelClick"
        >
          <i class="n-i n-i-trash" />
          <span>{{ getTranslation('actions.cancel') }}</span>
        </button>
      </div>

      <div v-if="showPayoutAction">
        <button
          class="btn btn-primary btn-block ripple max-height"
          @click="handlePayoutClick"
        >
          <i class="n-i n-i-currency" />
          <span>{{ getTranslation('actions.payout') }}</span>
        </button>
      </div>

      <div v-if="showRebetAction">
        <button
          class="btn btn-primary btn-block ripple max-height"
          @click="handleRebetClick"
        >
          <i class="n-i n-i-refresh-a" />
          <span>{{ getTranslation('actions.rebet') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import TicketCheckHeader from './TicketCheckHeader.vue';
import TicketCheckFooter from './TicketCheckFooter.vue';
import BetRow from './BetRow.vue';
import helpers from '../../../services/helpers';

export default {
  components: {
    TicketCheckHeader,
    TicketCheckFooter,
    BetRow,
  },
  data() {
    return {
      payoutActionValues: ['WON', 'CASHBACK'],
      rebetActionValues: ['REJECTED', 'OPEN'],
    };
  },
  computed: {
    ticket() {
      return this.$store.getters.getCheckedTicket;
    },
    oddType() {
      return this.$store.getters.getOddType;
    },
    showCancelAction() {
      return this.ticket.cancellable && !this.isUserOperator;
    },
    showRebetAction() {
      return this.rebetActionValues.includes((this.ticket.status || {}).value)
        && !this.isUserOperator;
    },
    showPayoutAction() {
      return this.payoutActionValues.includes((this.ticket.status || {}).value);
    },
    userType() {
      return this.$store.getters.getUserType;
    },
    isUserOperator() {
      return this.userType === 'OPERATOR';
    },
    isSystem() {
      return parseInt(this.ticket.type, 10) === 2;
    },
  },
  methods: {
    getTranslation(key) {
      return this.$store.getters.getTranslation(key);
    },
    handlePayoutClick() {
      const payoutTicketPayload = {
        ticket: this.ticket,
      };

      this.$store.dispatch('payoutTicket', payoutTicketPayload);
    },
    handleCancelClick() {
      const cancelTicketPayload = {
        ticket: this.ticket,
      };

      this.$store.dispatch('cancelTicket', cancelTicketPayload);
    },
    handleRebetClick() {
      this.$store.dispatch('rebetTicket', this.ticket);
    },
    convertOdd: helpers.toLocaleOdd,
    formatNumber: helpers.formatNumber,
  },
};
</script>

<style lang="scss">
@import '../../../scss/default/modules/ticket-check';
</style>
